import React from "react";

import { CircularProgress } from "@material-ui/core";

import { Container } from "./styles";

const Loader = ({ className }: { className?: any }) => (
  <Container className={className}>
    <CircularProgress color="primary" />
  </Container>
);

export default Loader;
